module.exports = __webpack_public_path__ + "img/varied_three.2975b704.png";